var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoadingLine',{attrs:{"title":"Danh sách đang được tổng kết","count":_vm.period.progress}})
}
var staticRenderFns = []

export { render, staticRenderFns }